import React from 'react';

import { createEntity } from '../../reference-material/reference-material.reducer';
import { ModalCreateEntity } from '../../../shared/components/modal-create-entity';

export const ModalReferenceMaterialCreate = () => {
  return <ModalCreateEntity createEntity={createEntity} entityKey="referenceMaterial" />;
};
